import { WizardStep } from "./WizardStep";


export abstract class WizardModel<TStep extends WizardStep<TSharedModel>, TSharedModel> {

    public abstract name: string;
    public activeStep?: TStep;
    public steps: Array<TStep> = [];
    public sharedModel?: TSharedModel;

}